/**
 * Local-calendar date helpers.
 *
 * Due dates are picked with a date-only input and stored as local midnight of the chosen
 * day, so reading them back has to happen in local time too. `toISOString().slice(0, 10)`
 * gives the UTC date, which for anyone east of UTC is the day before.
 */

const pad = (n) => String(n).padStart(2, '0');

/**
 * @param {Date|string|number} value
 * @returns {string} The local date as `YYYY-MM-DD` — the format `<input type="date">` takes.
 */
export const toLocalDateKey = (value) => {
    const date = value instanceof Date ? value : new Date(value);
    return `${date.getFullYear()}-${pad(date.getMonth() + 1)}-${pad(date.getDate())}`;
};

/**
 * Midnight at the start of the local day after `value` — where a date-only due date ends.
 * Built from calendar fields rather than adding 24h, so DST days still land on midnight.
 */
export const startOfNextLocalDay = (value) => {
    const date = value instanceof Date ? value : new Date(value);
    return new Date(date.getFullYear(), date.getMonth(), date.getDate() + 1);
};

/** `value` moved by `days` calendar days, keeping its local time of day. */
export const addDays = (value, days) => {
    const date = new Date(value instanceof Date ? value.getTime() : value);
    date.setDate(date.getDate() + days);
    return date;
};
